import { render, staticRenderFns } from "./zgzs.vue?vue&type=template&id=b361b6dc"
import script from "./zgzs.vue?vue&type=script&lang=js"
export * from "./zgzs.vue?vue&type=script&lang=js"
import style0 from "./zgzs.vue?vue&type=style&index=0&id=b361b6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports